(function() {
  const applyCustomStyles = () => {
    const formElement = document.querySelector('shopify-forms-embed');

    if (formElement && formElement.shadowRoot) {
      const shadow = formElement.shadowRoot;

      if (!shadow.querySelector('#custom-shopify-form-styles')) {
        const style = document.createElement('style');
        style.id = 'custom-shopify-form-styles';
        
        style.textContent = `
          section[data-sizing="form-wrapper"] { 
            max-width: none !important; 
          }
          
          section[data-sizing="form-wrapper"] section:has(h2) {
            margin-block: 32px 20px !important;
          }

          section[data-sizing="form-wrapper"] section h2 {
            color: #151803 !important;
            font-family: "Inter Tight" !important;
            font-size: 20px !important;
            font-style: normal !important;
            font-weight: 400 !important;
            line-height: 125% !important;
            letter-spacing: 0.2px !important;
            text-transform: capitalize !important;
          }

          section[data-sizing="form-wrapper"] section div p {
            color: #151803 !important;
            font-family: "Inter Tight" !important;
            font-size: 16px !important;
            font-style: normal !important;
            font-weight: 300 !important;
            line-height: 130% !important;
            letter-spacing: 0.16px !important;
          }

          section[data-sizing="form-wrapper"] a[href^="tel:"] {
            color: #151803 !important;
          }

          section[data-sizing="form-wrapper"] form {
            gap: 0 !important;
            padding: 0 !important;
          }

          section[data-sizing="form-wrapper"] input {
            box-shadow: none !important;
            border-bottom: 0.5px solid #000 !important;
            padding: 20px 0 !important;
            border-radius: 0 !important;
            color: #151803 !important;
            font-family: "Inter Tight" !important;
            font-size: 16px !important;
            font-style: normal !important;
            font-weight: 300 !important;
            line-height: 120% !important;
            letter-spacing: 0.16px !important;
          }
          
          section[data-sizing="form-wrapper"] input:focus + label,
          section[data-sizing="form-wrapper"] input:not(:placeholder-shown) + label {
            left: 0 !important;
            top: 0 !important;
            transform: translateY(20%) scale(0.8) !important;
            color: #151803 !important;
          }

          section[data-sizing="form-wrapper"] label {
            color: rgba(21, 24, 3, 0.37) !important;
            font-family: "Inter Tight" !important;
            font-size: 16px !important;
            font-style: normal !important;
            font-weight: 300 !important;
            line-height: 120% !important;
            letter-spacing: 0.16px !important;
            text-transform: capitalize !important;
            left: 0 !important;
          }

          section[data-sizing="form-wrapper"] button {
            max-width: 697px !important;
            color: white !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            width: auto !important;
            padding: 29px !important;
            border-radius: 999px !important;
            border: .2px solid rgba(255, 255, 255, .4) !important;
            background: #868b6a !important;
            text-align: center !important;
            font-family: "Inter Tight" !important;
            font-size: 20px !important;
            font-style: normal !important;
            font-weight: 400 !important;
            line-height: 110% !important;
            letter-spacing: 2px !important;
            text-transform: uppercase !important;
            margin-top: 32px !important;
          }

          @media screen and (max-width: 580px) {
            section[data-sizing="form-wrapper"] section:has(h2) {
              margin-block: 24px 12px !important;
            }

            section[data-sizing="form-wrapper"] section div p {
              font-size: 14px !important;
            }

            section[data-sizing="form-wrapper"] input {
              padding: 16px 0 !important;
              font-size: 14px !important;
            }
            
            section[data-sizing="form-wrapper"] input:focus + label,
            section[data-sizing="form-wrapper"] input:not(:placeholder-shown) + label {
              transform: translateY(20%) scale(0.8) !important;
              color: #151803 !important;
            }

            section[data-sizing="form-wrapper"] label {
              font-size: 14px !important;
            }

            section[data-sizing="form-wrapper"] button {
              padding: 16px !important;
              font-size: 15px !important;
              letter-spacing: 1.5px !important;
              margin-top: 24px !important;
            }
          }
        `;
        
        shadow.appendChild(style);
        console.log("Shopify Forms custom styling applied.");
      }

      const phoneLinks = shadow.querySelectorAll('a[href^="tel:"]');
      phoneLinks.forEach(link => {
          if (link.hasAttribute('target')) {
            link.removeAttribute('target');
          }
      });
    }
  };

  const observer = new MutationObserver(() => {
    applyCustomStyles();
  });

  observer.observe(document.body, { 
    childList: true, 
    subtree: true 
  });
  
  applyCustomStyles();
})();